t = require('views/internal/teacup-with-helpers')('card_detail_more_menu')

module.exports = ->
  t.ul '.pop-over-list', ->

    t.li ->
      t.a '.js-print', { href: '#' }, ->
        t.format 'print-ellipsis'

    t.li ->
      t.a '.js-export-json', { href: t.mustacheVar('jsonURL') }, ->
        t.format 'export-json'

  t.mustachePartial 'meta'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/card_detail_more_menu.coffee